import { FC } from "react";
import {
    Dialog,
    DialogActions,
    ThemeProvider,
    Theme,
    StyledEngineProvider,
    Tooltip,
    Box,
} from "@mui/material";
import { FlatButton } from "src/framework/components/buttons/FlatButton";
import { SugestaoInstalacao } from "../types";
import { LocalStorage } from "src/framework/commons/LocalStorage";
import ReactDOMServer from "react-dom/server";
import moment from "moment";
import { ConteudoModalModulosString } from "./ConteudoModalModulosString";
import theme from "src/theme/light";
import "./style.css";
import { ConteudoModalInstalacao } from "../ModalInstalacao/ConteudoModalInstalacao";


declare module '@mui/styles/defaultTheme' {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  interface DefaultTheme extends Theme {}
}


export interface ModalModulosStringsProps {
    isOpened: boolean;
    close: () => void;
    onBack: () => void;
    onChange: (sugestao_instalacao: SugestaoInstalacao) => void;
    modulosInversoresState: any[];
    componentesState: any[];
}

const ModalModulosStrings: FC<ModalModulosStringsProps> = ({ isOpened, close, onBack, onChange, componentesState, modulosInversoresState  }) => {
    const userInfo = LocalStorage.get("solar.userExtraInfo", true);
    const modalContent = (
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={theme}>
                <ConteudoModalModulosString />
            </ThemeProvider>
        </StyledEngineProvider>
    );

    return (
        <>
            <div>
                <Dialog
                    open={isOpened}
                    onClose={close}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    maxWidth='md'
                >
                
                    { <ConteudoModalInstalacao componentesState={componentesState} modulosInversoresState={modulosInversoresState} alerta={modalContent} /> }

                    <DialogActions>
                        <Tooltip title="Você será direcionado para alterar a quantidade/modelo de módulos ou inversor.">
                            <Box>
                                <FlatButton
                                    color="secondary"
                                    variant="outlined"
                                    disableElevation
                                    text="Alterar Quantidades"
                                    onClick={onBack}
                                />
                            </Box>
                        </Tooltip>
                    
                        <Tooltip title="Ao selecionar essa opção, você está ciente e de acordo com a orientação realizada.">
                            <Box>
                                <FlatButton
                                    color="primary"
                                    variant="contained"
                                    disableElevation
                                    text="Estou Ciente"
                                    onClick={() => {
                                        onChange({
                                            user_id: userInfo?.userId,
                                            user_name: userInfo?.name,
                                            alerta: ReactDOMServer.renderToString(modalContent),
                                            confirmado_em: moment().format("yyyy-MM-DD HH:mm:ss"),
                                        })
                                    }}
                                />
                            </Box>
                        </Tooltip>
                    </DialogActions>
                </Dialog>
            </div>
        </>
    );
};

export { ModalModulosStrings };
